var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppointmentUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.49 5.5C17.86 3.62 16.1 2.25 14 2.25H7C4.38 2.25 2.25 4.38 2.25 7V14C2.25 16.09 3.62 17.85 5.5 18.49C6.14 20.42 7.94 21.75 10 21.75H17C19.62 21.75 21.75 19.62 21.75 17V10C21.75 7.94 20.42 6.14 18.49 5.5ZM3.75 14V7C3.75 5.21 5.21 3.75 7 3.75H14C15.79 3.75 17.25 5.21 17.25 7V14C17.25 15.79 15.79 17.25 14 17.25H7C5.21 17.25 3.75 15.79 3.75 14ZM20.25 17C20.25 18.79 18.79 20.25 17 20.25H10C8.87 20.25 7.85 19.66 7.26 18.75H14C16.62 18.75 18.75 16.62 18.75 14V7.26C19.66 7.84 20.25 8.86 20.25 10V17Z",
    fill: "var(--color-color7)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11.75C12.29 11.75 13.75 10.29 13.75 8.5C13.75 6.71 12.29 5.25 10.5 5.25C8.71 5.25 7.25 6.71 7.25 8.5C7.25 10.29 8.71 11.75 10.5 11.75ZM10.5 6.75C11.46 6.75 12.25 7.54 12.25 8.5C12.25 9.46 11.46 10.25 10.5 10.25C9.54 10.25 8.75 9.46 8.75 8.5C8.75 7.54 9.54 6.75 10.5 6.75Z",
    fill: "var(--color-color7)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.23977 13.7502H12.7698C13.2498 13.7502 13.6798 14.0102 13.8898 14.4402L14.3398 15.3302C14.4698 15.5902 14.7398 15.7402 15.0098 15.7402C15.1198 15.7402 15.2398 15.7102 15.3398 15.6602C15.7098 15.4702 15.8598 15.0202 15.6798 14.6502L15.2298 13.7602C14.7598 12.8202 13.8198 12.2402 12.7698 12.2402H8.23977C7.18977 12.2402 6.24977 12.8202 5.77977 13.7602L5.32977 14.6502C5.13977 15.0202 5.28977 15.4702 5.66977 15.6602C6.03977 15.8502 6.48977 15.6902 6.67977 15.3202L7.12977 14.4302C7.33977 14.0002 7.76977 13.7402 8.24977 13.7402L8.23977 13.7502Z",
    fill: "var(--color-color7)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentUser);
export default __webpack_public_path__ + "static/media/appointment-user.0ca9d8a7151dc15fe01b48dee1803089.svg";
export { ForwardRef as ReactComponent };